import {
    Avatar,
    Box,
    Button,
    Divider,
    Grid,
    Stack,
    Tab,
    Typography
} from "@mui/material";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Chip from "@mui/material/Chip";
import { Link, useLocation } from "react-router-dom";
import React, { useEffect } from "react";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import pdfIcon from "../../assets/images/pdfIcon.png";
import { viewCoPoDetails } from "../Services/OrgRepo";
import { generatProfilePicUrl, getFile } from "../../Utils/Constant";
import { ThreeDot } from "react-loading-indicators";
import emptyImage from "../../assets/images/image.png";
import {
    DELIVERY_TYPE_OPTIONS,
    GST_APPLY_OPTIONS,
    GST_TYPE_OPTIONS,
    SCROLL_Y
} from "./CoPoConstants";
import { Earbuds } from "@mui/icons-material";

export const ViewCoPo = () => {
    const location = useLocation();
    const storedData = JSON.parse(localStorage.getItem("ViewCoPo") || "null");
    const coPoData = location?.state?.coPoData || storedData?.coPoData;
    
    // const coPoData = location?.state?.coPoData;
    const testProfileUrl = ``;
    const [value, setValue] = React.useState("1");
    const [loading, setLoading] = React.useState(false);
    const [coPoExtention, setCoPoExtention] = React.useState("");
    const [isProductionTeamMemberAssigned, setIsProductionTeamMemberAssigned] =
        React.useState(false);
    const [isQualityTeamMemberAssigned, setIsQualityTeamMemberAssigned] =
        React.useState(false);
    const [noRecordsFoundFlag, setNoRecordFoundFlag] = React.useState(false);

    const [scrolled, setScrolled] = React.useState(false);

    React.useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > SCROLL_Y);
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    type BasicAndGeneralDetails = {
        basic_information: any;
        general_details: any;
        terms_and_conditions: any;
        purchase_order_value: any;
    };

    type PageStates = {
        basicAndGeneralDetails: BasicAndGeneralDetails;
        partDetails: any[];
        toolDetails: any[];
        customPoDocumentDetails: string;
    };
    const [pageDetails, setPageDetails] = React.useState<PageStates>({
        basicAndGeneralDetails: {
            basic_information: [],
            general_details: [],
            terms_and_conditions: [],
            purchase_order_value: []
        },
        partDetails: [],
        toolDetails: [],
        customPoDocumentDetails: ""
    });

    const KamProfileUrl = generatProfilePicUrl(
        coPoData?.kamID,
        coPoData?.kamImgPath,
        "Profile_Picture"
    );

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    const fetchCoPoData = async () => {
        setLoading(true);
        try {
            const allCoPoDataRes = await viewCoPoDetails({
                ID: coPoData?.coPoID
            });

            if (
                allCoPoDataRes?.data?.message ===
                    "No records exist in this report." ||
                allCoPoDataRes?.data?.code === 9220
            ) {
                setNoRecordFoundFlag(true);
            } else if (allCoPoDataRes?.status) {
                const allCoPoData = allCoPoDataRes?.data[0];

                const extension =
                    allCoPoData?.documents?.COPO_Document.substring(
                        allCoPoData?.documents?.COPO_Document.lastIndexOf(".") +
                            1
                    );
                setCoPoExtention(`CompanyPurchaseOrder.${extension}`);

                setPageDetails({
                    basicAndGeneralDetails:
                        allCoPoData?.basic_info_and_general_det ?? [],
                    partDetails: allCoPoData?.part_details ?? [],
                    toolDetails: allCoPoData?.tool_details ?? [],
                    customPoDocumentDetails:
                        allCoPoData?.documents?.COPO_Document ?? []
                });
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);

            console.log("error while fetching overview data", error);
        }
    };

    useEffect(() => {
        fetchCoPoData();
    }, []);

    return (
        <>
            {/* BreadCrubs Section - Start */}
            <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 1.5 }}>
                <Typography fontSize={14}>Home</Typography>
                <Typography fontSize={14}>Production</Typography>
                <Link
                    to="/layout/CoPoDatatable"
                    style={{
                        color: "#0070BA",
                        fontSize: "14px",
                        textDecoration: "none"
                    }}
                >
                    Company Purchase Orders
                </Link>
                <Typography fontSize={14} color="#00000099">
                    {coPoData?.ID || "-"} Company Purchase Order Details
                </Typography>
            </Breadcrumbs>
            {/* BreadCrubs Section - End */}

            {!noRecordsFoundFlag ? (
                <>
                    {/* Header Section - Start */}
                    <Box
                        mb={2}
                        sx={{
                            display: "flex",
                            justifyContent: "space-between"
                        }}
                    >
                        <Box px={1}>
                            <Typography fontWeight={600} mb={0.5}>
                                {coPoData?.ID || "-"} Company Purchase Order
                                Details
                            </Typography>

                            <Stack
                                direction="row"
                                alignItems="center"
                                spacing={1.5}
                                flexWrap="wrap"
                            >
                                {/* RFQ Number */}
                                <Typography fontSize={14} color="#00000099">
                                    {coPoData?.coRfqNo || "-"}
                                </Typography>

                                <Divider
                                    orientation="vertical"
                                    sx={{ margin: "0 10px" }}
                                    variant="middle"
                                    flexItem
                                />

                                {/* Status */}
                                <Chip
                                    color="info"
                                    variant="outlined"
                                    size="small"
                                    label="Open"
                                />

                                <Divider
                                    orientation="vertical"
                                    sx={{ margin: "0 10px" }}
                                    variant="middle"
                                    flexItem
                                />

                                {/* Added Time */}
                                <Typography fontSize={14} color="#00000099">
                                    Added On : {coPoData?.addedOn || "-"}
                                </Typography>

                                <Divider
                                    orientation="vertical"
                                    sx={{ margin: "0 10px" }}
                                    variant="middle"
                                    flexItem
                                />

                                {/* KAM */}
                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    spacing={0.5}
                                >
                                    {/* <Typography fontSize={14} color="#00000099">
                {coPoData?.kamName}
              </Typography> */}
                                    <Avatar
                                        alt="KAM"
                                        src={KamProfileUrl}
                                        sx={{ width: 30, height: 30 }}
                                    />
                                    <Typography fontSize={14} color="#00000099">
                                        Key Account Manager
                                    </Typography>
                                </Stack>

                                {/* Production */}
                                {isProductionTeamMemberAssigned && (
                                    <>
                                        <Divider
                                            orientation="vertical"
                                            sx={{ margin: "0 10px" }}
                                            variant="middle"
                                            flexItem
                                        />
                                        <Stack
                                            direction="row"
                                            alignItems="center"
                                            spacing={0.5}
                                        >
                                            <Chip
                                                color="default"
                                                variant="outlined"
                                                size="small"
                                                label="Not Yet Assigned"
                                            />
                                            <Avatar
                                                alt="Production"
                                                src={testProfileUrl}
                                                sx={{ width: 30, height: 30 }}
                                            />
                                        </Stack>

                                        <Divider
                                            orientation="vertical"
                                            sx={{ margin: "0 10px" }}
                                            variant="middle"
                                            flexItem
                                        />
                                    </>
                                )}

                                {/* Quality */}
                                {isProductionTeamMemberAssigned && (
                                    <>
                                        <Stack
                                            direction="row"
                                            alignItems="center"
                                            spacing={0.5}
                                        >
                                            <Chip
                                                color="default"
                                                variant="outlined"
                                                size="small"
                                                label="Not Yet Assigned"
                                            />
                                            <Avatar
                                                alt="Quality"
                                                src={testProfileUrl}
                                                sx={{ width: 30, height: 30 }}
                                            />
                                            <Typography
                                                fontSize={14}
                                                color="#00000099"
                                            >
                                                Quality
                                            </Typography>
                                        </Stack>
                                    </>
                                )}
                            </Stack>
                        </Box>
                        {/* Action button feature */}
                        {/* <Box px={1}>
          <Button
            size="small"
            variant="contained"
            color="error"
            sx={{ marginRight: "5px" }}
            onClick={() => ""}
            disabled={true}
          >
            VOID
          </Button>
          <Button
            size="small"
            variant="contained"
            color="info"
            sx={{ marginRight: "5px" }}
            onClick={() => ""}
            disabled={true}
          >
            REVISE
          </Button>
        </Box> */}
                    </Box>
                    {/* Header Section - End */}

                    {/* Accordian Section - Start */}
                    <Box
                        sx={{
                            width: "100%",
                            typography: "body1"
                        }}
                        mt={2}
                    >
                        <TabContext value={value}>
                            <Box
                                sx={{
                                    position: "sticky",
                                    top: 60,
                                    zIndex: 1000,
                                    backgroundColor: scrolled
                                        ? "#fff"
                                        : "transparent",
                                    boxShadow: scrolled
                                        ? "0 2px 6px rgba(0,0,0,0.08)"
                                        : "none",
                                    transition: "all .2s ease"
                                }}
                            >
                                <TabList onChange={handleChange}>
                                    <Tab label="General Details" value="1" />
                                    <Tab label="Parts & Tools" value="2" />
                                    <Tab label="Documents" value="3" />
                                </TabList>
                            </Box>
                            <Box
                                sx={{
                                    borderRadius: "5px",
                                    marginTop: "16px",
                                    background: "#fff",
                                    padding: "0px"
                                }}
                            >
                                {/* Basic Information, General Details Section & Terms and Conditions - Start */}
                                {!loading ? (
                                    <TabPanel value="1">
                                        {/* Basic Information */}
                                        <Typography
                                            variant="h6"
                                            fontWeight="bold"
                                            mb={2}
                                            color="primary"
                                        >
                                            Basic Information
                                        </Typography>

                                        {Object.keys(
                                            pageDetails?.basicAndGeneralDetails
                                                ?.basic_information
                                        ).length > 0 ? (
                                            <Box
                                                display="grid"
                                                gridTemplateColumns="repeat(4, 1fr)"
                                                gap={4}
                                                width="100%"
                                            >
                                                <Stack spacing={0.5}>
                                                    <Typography
                                                        variant="body2"
                                                        color="text.secondary"
                                                    >
                                                        Name of the Company
                                                    </Typography>
                                                    <Typography variant="body2">
                                                        {pageDetails
                                                            ?.basicAndGeneralDetails
                                                            ?.basic_information
                                                            ?.Name_of_the_Company ||
                                                            "-"}
                                                    </Typography>
                                                </Stack>

                                                <Stack spacing={0.5}>
                                                    <Typography
                                                        variant="body2"
                                                        color="text.secondary"
                                                    >
                                                        CORFQ ID
                                                    </Typography>
                                                    <Typography variant="body2">
                                                        {" "}
                                                        {pageDetails
                                                            ?.basicAndGeneralDetails
                                                            ?.basic_information
                                                            ?.CORFQ_ID || "-"}
                                                    </Typography>
                                                </Stack>

                                                <Stack spacing={0.5}>
                                                    <Typography
                                                        variant="body2"
                                                        color="text.secondary"
                                                    >
                                                        COPO Number
                                                    </Typography>
                                                    <Typography variant="body2">
                                                        {" "}
                                                        {pageDetails
                                                            ?.basicAndGeneralDetails
                                                            ?.basic_information
                                                            ?.COPO_Number ||
                                                            "-"}
                                                    </Typography>
                                                </Stack>

                                                <Stack spacing={0.5}>
                                                    <Typography
                                                        variant="body2"
                                                        color="text.secondary"
                                                    >
                                                        COPO Date
                                                    </Typography>
                                                    <Typography variant="body2">
                                                        {" "}
                                                        {pageDetails
                                                            ?.basicAndGeneralDetails
                                                            ?.basic_information
                                                            ?.COPO_Date || "-"}
                                                    </Typography>
                                                </Stack>

                                                {/* Next row */}
                                                <Stack spacing={0.5}>
                                                    <Typography
                                                        variant="body2"
                                                        color="text.secondary"
                                                    >
                                                        MM GST Number
                                                    </Typography>
                                                    <Typography variant="body2">
                                                        {" "}
                                                        {pageDetails
                                                            ?.basicAndGeneralDetails
                                                            ?.basic_information
                                                            ?.MM_GST_Number ||
                                                            "-"}
                                                    </Typography>
                                                </Stack>

                                                <Stack spacing={0.5}>
                                                    <Typography
                                                        variant="body2"
                                                        color="text.secondary"
                                                    >
                                                        Machinemaze Address
                                                    </Typography>
                                                    <Typography variant="body2">
                                                        {" "}
                                                        {pageDetails
                                                            ?.basicAndGeneralDetails
                                                            ?.basic_information
                                                            ?.Machinemaze_Address ||
                                                            "-"}
                                                    </Typography>
                                                </Stack>

                                                <Stack spacing={0.5}>
                                                    <Typography
                                                        variant="body2"
                                                        color="text.secondary"
                                                    >
                                                        Billing Address
                                                    </Typography>
                                                    <Typography variant="body2">
                                                        {" "}
                                                        {pageDetails
                                                            ?.basicAndGeneralDetails
                                                            ?.basic_information
                                                            ?.Billing_Address ||
                                                            "-"}
                                                    </Typography>
                                                </Stack>

                                                <Stack spacing={0.5}>
                                                    <Typography
                                                        variant="body2"
                                                        color="text.secondary"
                                                    >
                                                        Delivery Address
                                                    </Typography>
                                                    <Typography variant="body2">
                                                        {" "}
                                                        {pageDetails
                                                            ?.basicAndGeneralDetails
                                                            ?.basic_information
                                                            ?.Delivery_Address ||
                                                            "-"}
                                                    </Typography>
                                                </Stack>
                                            </Box>
                                        ) : (
                                            <>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "center",
                                                        gap: "8px",
                                                        padding: "20px",
                                                        color: "#0009"
                                                    }}
                                                >
                                                    <>
                                                        <img
                                                            src={emptyImage}
                                                            alt="Empty"
                                                            width={"300px"}
                                                        />
                                                        <b>
                                                            No Basic Information
                                                            available
                                                        </b>
                                                    </>
                                                </div>
                                            </>
                                        )}

                                        <Divider sx={{ mb: 2, mt: 4 }} />

                                        {/* General Details */}
                                        <Typography
                                            variant="h6"
                                            fontWeight="bold"
                                            mt={4}
                                            mb={2}
                                            color="primary"
                                        >
                                            General Details
                                        </Typography>

                                        {Object.keys(
                                            pageDetails?.basicAndGeneralDetails
                                                ?.general_details
                                        ).length > 0 ? (
                                            <Box
                                                display="grid"
                                                gridTemplateColumns="repeat(4, 1fr)"
                                                gap={4}
                                                width="100%"
                                            >
                                                <Stack spacing={0.5}>
                                                    <Typography
                                                        variant="body2"
                                                        color="text.secondary"
                                                    >
                                                        Purchase Order Type
                                                    </Typography>
                                                    <Typography variant="body2">
                                                        {pageDetails
                                                            ?.basicAndGeneralDetails
                                                            ?.general_details
                                                            ?.Purchase_Order_Type ||
                                                            "-"}
                                                    </Typography>
                                                </Stack>

                                                <Stack spacing={0.5}>
                                                    <Typography
                                                        variant="body2"
                                                        color="text.secondary"
                                                    >
                                                        Delivery Type
                                                    </Typography>
                                                    <Typography variant="body2">
                                                        {pageDetails
                                                            ?.basicAndGeneralDetails
                                                            ?.general_details
                                                            ?.Delivery_Type ||
                                                            "-"}
                                                    </Typography>
                                                </Stack>

                                                {pageDetails
                                                    ?.basicAndGeneralDetails
                                                    ?.general_details
                                                    ?.Delivery_Type ===
                                                    DELIVERY_TYPE_OPTIONS[2] && (
                                                    <Stack spacing={0.5}>
                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                        >
                                                            Delivery Date
                                                        </Typography>
                                                        <Typography variant="body2">
                                                            {pageDetails
                                                                ?.basicAndGeneralDetails
                                                                ?.general_details
                                                                ?.Delivery_Date ||
                                                                "-"}
                                                        </Typography>
                                                    </Stack>
                                                )}

                                                <Stack spacing={0.5}>
                                                    <Typography
                                                        variant="body2"
                                                        color="text.secondary"
                                                    >
                                                        Contact Person
                                                    </Typography>
                                                    <Typography variant="body2">
                                                        {pageDetails
                                                            ?.basicAndGeneralDetails
                                                            ?.general_details
                                                            ?.Contact_Person ||
                                                            "-"}
                                                    </Typography>
                                                </Stack>

                                                <Stack spacing={0.5}>
                                                    <Typography
                                                        variant="body2"
                                                        color="text.secondary"
                                                    >
                                                        Contact Number
                                                    </Typography>
                                                    <Typography variant="body2">
                                                        {pageDetails
                                                            ?.basicAndGeneralDetails
                                                            ?.general_details
                                                            ?.Contact_Number ||
                                                            "-"}
                                                    </Typography>
                                                </Stack>

                                                <Stack spacing={0.5}>
                                                    <Typography
                                                        variant="body2"
                                                        color="text.secondary"
                                                    >
                                                        Contact Email
                                                    </Typography>
                                                    <Typography variant="body2">
                                                        {pageDetails
                                                            ?.basicAndGeneralDetails
                                                            ?.general_details
                                                            ?.Contact_Email ||
                                                            "-"}
                                                    </Typography>
                                                </Stack>

                                                <Stack spacing={0.5}>
                                                    <Typography
                                                        variant="body2"
                                                        color="text.secondary"
                                                    >
                                                        GST Applicable
                                                    </Typography>
                                                    <Typography variant="body2">
                                                        {pageDetails
                                                            ?.basicAndGeneralDetails
                                                            ?.general_details
                                                            ?.GST_Applicable ||
                                                            "-"}
                                                    </Typography>
                                                </Stack>

                                                {pageDetails
                                                    ?.basicAndGeneralDetails
                                                    ?.general_details
                                                    ?.GST_Applicable ===
                                                GST_APPLY_OPTIONS[0] ? (
                                                    <Stack spacing={0.5}>
                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                        >
                                                            GST Type
                                                        </Typography>
                                                        <Typography variant="body2">
                                                            {pageDetails
                                                                ?.basicAndGeneralDetails
                                                                ?.general_details
                                                                ?.GST_Type ||
                                                                "-"}
                                                        </Typography>
                                                    </Stack>
                                                ) : (
                                                    <Stack spacing={0.5}>
                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                        >
                                                            Currency
                                                        </Typography>
                                                        <Typography variant="body2">
                                                            {`${pageDetails?.basicAndGeneralDetails?.general_details?.Currency} (${
                                                                pageDetails
                                                                    ?.basicAndGeneralDetails
                                                                    ?.general_details
                                                                    ?.CurrencySymbol
                                                            })` || "-"}
                                                        </Typography>
                                                    </Stack>
                                                )}

                                                {pageDetails
                                                    ?.basicAndGeneralDetails
                                                    ?.general_details
                                                    ?.GST_Type ===
                                                    GST_TYPE_OPTIONS[0] && (
                                                    <Stack spacing={0.5}>
                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                        >
                                                            GST Percent (%)
                                                        </Typography>
                                                        <Typography variant="body2">
                                                            {pageDetails
                                                                ?.basicAndGeneralDetails
                                                                ?.general_details
                                                                ?.Selected_GST ||
                                                                "-"}
                                                        </Typography>
                                                    </Stack>
                                                )}
                                            </Box>
                                        ) : (
                                            <>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "center",
                                                        gap: "8px",
                                                        padding: "20px",
                                                        color: "#0009"
                                                    }}
                                                >
                                                    <>
                                                        <img
                                                            src={emptyImage}
                                                            alt="Empty"
                                                            width={"300px"}
                                                        />
                                                        <b>
                                                            No General
                                                            Information
                                                            available
                                                        </b>
                                                    </>
                                                </div>
                                            </>
                                        )}

                                        <Divider sx={{ mb: 2, mt: 4 }} />

                                        {/* Terms and Conditions Section */}
                                        <Typography
                                            variant="h6"
                                            fontWeight="bold"
                                            mt={4}
                                            mb={2}
                                            color="primary"
                                        >
                                            Terms and Conditions
                                        </Typography>

                                        {Object.keys(
                                            pageDetails?.basicAndGeneralDetails
                                                ?.terms_and_conditions
                                        ).length > 0 ? (
                                            <Box
                                                display="grid"
                                                gridTemplateColumns="repeat(4, 1fr)"
                                                gap={4}
                                                width="100%"
                                                mb={4}
                                            >
                                                <Stack spacing={0.5}>
                                                    <Typography
                                                        variant="body2"
                                                        color="text.secondary"
                                                    >
                                                        Payment Term
                                                    </Typography>
                                                    <Typography variant="body2">
                                                        {pageDetails
                                                            ?.basicAndGeneralDetails
                                                            ?.terms_and_conditions
                                                            ?.Payment_terms ||
                                                            "-"}
                                                    </Typography>
                                                </Stack>

                                                <Stack spacing={0.5}>
                                                    <Typography
                                                        variant="body2"
                                                        color="text.secondary"
                                                    >
                                                        IncoTerm
                                                    </Typography>
                                                    <Typography variant="body2">
                                                        {pageDetails
                                                            ?.basicAndGeneralDetails
                                                            ?.terms_and_conditions
                                                            ?.Inco_Terms || "-"}
                                                    </Typography>
                                                </Stack>

                                                <Stack
                                                    spacing={0.5}
                                                    paddingRight={"1rem"}
                                                    sx={{
                                                        gridColumn: "span 2"
                                                    }}
                                                >
                                                    <Typography
                                                        variant="body2"
                                                        color="text.secondary"
                                                    >
                                                        Other Terms and
                                                        Conditions
                                                    </Typography>
                                                    <Typography variant="body2">
                                                        {pageDetails
                                                            ?.basicAndGeneralDetails
                                                            ?.terms_and_conditions
                                                            ?.Other_Terms_And_Conditions ||
                                                            "-"}
                                                    </Typography>
                                                </Stack>
                                            </Box>
                                        ) : (
                                            <>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "center",
                                                        gap: "8px",
                                                        padding: "20px",
                                                        color: "#0009"
                                                    }}
                                                >
                                                    <>
                                                        <img
                                                            src={emptyImage}
                                                            alt="Empty"
                                                            width={"300px"}
                                                        />
                                                        <b>
                                                            No Terms and
                                                            Conditions available
                                                        </b>
                                                    </>
                                                </div>
                                            </>
                                        )}
                                    </TabPanel>
                                ) : (
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        height="50vh"
                                    >
                                        <ThreeDot
                                            color="#1976d2"
                                            size="medium"
                                            text=""
                                            textColor=""
                                        />
                                    </Box>
                                )}
                                {/* Basic Information, General Details Section & Terms and Conditions - End */}

                                {/* Part & Tools Details Section - Start */}
                                {!loading ? (
                                    <TabPanel value="2">
                                        {/* Parts Details */}
                                        <Typography
                                            variant="h6"
                                            fontWeight="bold"
                                            mb={2}
                                            color="primary"
                                        >
                                            Parts Details
                                        </Typography>

                                        {pageDetails?.partDetails?.length ? (
                                            pageDetails.partDetails.map(
                                                (
                                                    eachPartrec: any,
                                                    index: number
                                                ) => (
                                                    <>
                                                        <Box
                                                            key={index}
                                                            mb={3}
                                                            style={{
                                                                background:
                                                                    "#f5f7f8",
                                                                padding: "15px",
                                                                marginBottom:
                                                                    "15px"
                                                            }}
                                                        >
                                                            <Typography
                                                                fontSize={14}
                                                                fontWeight="bold"
                                                                mb={1}
                                                            >
                                                                Part {index + 1}
                                                                :{" "}
                                                                {eachPartrec?.Part_Name ||
                                                                    "-"}
                                                            </Typography>

                                                            <Typography
                                                                fontSize={14}
                                                                color="#00000099"
                                                                fontWeight="bold"
                                                                mb={2}
                                                            >
                                                                Part Number :{" "}
                                                                {eachPartrec?.Part_No ||
                                                                    "-"}
                                                            </Typography>

                                                            <Box
                                                                display="grid"
                                                                gridTemplateColumns="repeat(4, 1fr)"
                                                                gap={4}
                                                                width="100%"
                                                            >
                                                                <Stack
                                                                    spacing={
                                                                        0.5
                                                                    }
                                                                >
                                                                    <Typography
                                                                        variant="body2"
                                                                        color="text.secondary"
                                                                    >
                                                                        HSN
                                                                    </Typography>
                                                                    <Typography variant="body2">
                                                                        {eachPartrec?.HSN_No ||
                                                                            "-"}
                                                                    </Typography>
                                                                </Stack>

                                                                <Stack
                                                                    spacing={
                                                                        0.5
                                                                    }
                                                                >
                                                                    <Typography
                                                                        variant="body2"
                                                                        color="text.secondary"
                                                                    >
                                                                        Unit Of
                                                                        Measurement
                                                                    </Typography>
                                                                    <Typography variant="body2">
                                                                        {eachPartrec?.UOM ||
                                                                            "-"}
                                                                    </Typography>
                                                                </Stack>

                                                                <Stack
                                                                    spacing={
                                                                        0.5
                                                                    }
                                                                >
                                                                    <Typography
                                                                        variant="body2"
                                                                        color="text.secondary"
                                                                    >
                                                                        Quantity
                                                                    </Typography>
                                                                    <Typography variant="body2">
                                                                        {eachPartrec?.Quantity ||
                                                                            "-"}
                                                                    </Typography>
                                                                </Stack>

                                                                <Stack
                                                                    spacing={
                                                                        0.5
                                                                    }
                                                                >
                                                                    <Typography
                                                                        variant="body2"
                                                                        color="text.secondary"
                                                                    >
                                                                        Unit
                                                                        Price
                                                                    </Typography>
                                                                    <Typography variant="body2">
                                                                        {`${eachPartrec?.Unit_Price}` ||
                                                                            "-"}
                                                                    </Typography>
                                                                </Stack>

                                                                {pageDetails
                                                                    ?.basicAndGeneralDetails
                                                                    ?.general_details
                                                                    ?.GST_Applicable ===
                                                                GST_APPLY_OPTIONS[0] ? (
                                                                    <>
                                                                        <Stack
                                                                            spacing={
                                                                                0.5
                                                                            }
                                                                        >
                                                                            <Typography
                                                                                variant="body2"
                                                                                color="text.secondary"
                                                                            >
                                                                                Total
                                                                                Amount
                                                                                (Excluding
                                                                                GST)
                                                                            </Typography>
                                                                            <Typography variant="body2">
                                                                                {`${eachPartrec?.Total_Amount_Exc_GST}` ||
                                                                                    "-"}
                                                                            </Typography>
                                                                        </Stack>

                                                                        <Stack
                                                                            spacing={
                                                                                0.5
                                                                            }
                                                                        >
                                                                            <Typography
                                                                                variant="body2"
                                                                                color="text.secondary"
                                                                            >
                                                                                Total
                                                                                Amount
                                                                                (Including
                                                                                GST)
                                                                            </Typography>
                                                                            <Typography variant="body2">
                                                                                {`${eachPartrec?.Total_Amount_Inc_GST}` ||
                                                                                    "-"}
                                                                            </Typography>
                                                                        </Stack>

                                                                        {pageDetails
                                                                            ?.basicAndGeneralDetails
                                                                            ?.general_details
                                                                            ?.GST_Type ===
                                                                            GST_TYPE_OPTIONS[1] && (
                                                                            <Stack
                                                                                spacing={
                                                                                    0.5
                                                                                }
                                                                            >
                                                                                <Typography
                                                                                    variant="body2"
                                                                                    color="text.secondary"
                                                                                >
                                                                                    GST
                                                                                    Percent
                                                                                    (%)
                                                                                </Typography>
                                                                                <Typography variant="body2">
                                                                                    {eachPartrec?.GST_Per_Part ||
                                                                                        "-"}
                                                                                </Typography>
                                                                            </Stack>
                                                                        )}
                                                                    </>
                                                                ) : (
                                                                    <Stack
                                                                        spacing={
                                                                            0.5
                                                                        }
                                                                    >
                                                                        <Typography
                                                                            variant="body2"
                                                                            color="text.secondary"
                                                                        >
                                                                            Total
                                                                            Amount
                                                                        </Typography>
                                                                        <Typography variant="body2">
                                                                            {`${eachPartrec?.Total_Amount_Exc_GST}` ||
                                                                                "-"}
                                                                        </Typography>
                                                                    </Stack>
                                                                )}

                                                                {pageDetails
                                                                    ?.basicAndGeneralDetails
                                                                    ?.general_details
                                                                    ?.Delivery_Type ===
                                                                    DELIVERY_TYPE_OPTIONS[1] && (
                                                                    <Stack
                                                                        spacing={
                                                                            0.5
                                                                        }
                                                                    >
                                                                        <Typography
                                                                            variant="body2"
                                                                            color="text.secondary"
                                                                        >
                                                                            Delivery_Date
                                                                        </Typography>
                                                                        <Typography variant="body2">
                                                                            {`${eachPartrec?.Delivery_Date}` ||
                                                                                "-"}
                                                                        </Typography>
                                                                    </Stack>
                                                                )}
                                                            </Box>
                                                            {pageDetails
                                                                ?.basicAndGeneralDetails
                                                                ?.general_details
                                                                ?.Delivery_Type ===
                                                                DELIVERY_TYPE_OPTIONS[0] &&
                                                            eachPartrec?.Batches
                                                                ?.length > 0
                                                                ? eachPartrec?.Batches?.map(
                                                                      (
                                                                          eachBatchRec: any,
                                                                          index: number
                                                                      ) => (
                                                                          <>
                                                                              <Typography
                                                                                  fontSize={
                                                                                      14
                                                                                  }
                                                                                  color="#00000099"
                                                                                  fontWeight="bold"
                                                                                  mt={
                                                                                      5
                                                                                  }
                                                                                  mb={
                                                                                      1
                                                                                  }
                                                                              >
                                                                                  Batch{" "}
                                                                                  {index +
                                                                                      1}

                                                                                  :{" "}
                                                                                  {`(${eachPartrec?.Part_No})` ||
                                                                                      "-"}
                                                                              </Typography>
                                                                              <Box
                                                                                  key={
                                                                                      index
                                                                                  }
                                                                                  mb={
                                                                                      3
                                                                                  }
                                                                                  display="grid"
                                                                                  gridTemplateColumns="repeat(4, 1fr)"
                                                                                  gap={
                                                                                      4
                                                                                  }
                                                                                  width="100%"
                                                                              >
                                                                                  <Stack
                                                                                      spacing={
                                                                                          0.5
                                                                                      }
                                                                                  >
                                                                                      <Typography
                                                                                          variant="body2"
                                                                                          color="text.secondary"
                                                                                      >
                                                                                          Quantity
                                                                                      </Typography>
                                                                                      <Typography variant="body2">
                                                                                          {eachBatchRec?.Qty ||
                                                                                              "-"}
                                                                                      </Typography>
                                                                                  </Stack>

                                                                                  <Stack
                                                                                      spacing={
                                                                                          0.5
                                                                                      }
                                                                                  >
                                                                                      <Typography
                                                                                          variant="body2"
                                                                                          color="text.secondary"
                                                                                      >
                                                                                          Date
                                                                                          of
                                                                                          Delivery
                                                                                      </Typography>
                                                                                      <Typography variant="body2">
                                                                                          {eachBatchRec?.Date_of_Delivery ||
                                                                                              "-"}
                                                                                      </Typography>
                                                                                  </Stack>
                                                                              </Box>
                                                                          </>
                                                                      )
                                                                  )
                                                                : null}
                                                        </Box>
                                                    </>
                                                )
                                            )
                                        ) : (
                                            <>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "center",
                                                        gap: "8px",
                                                        padding: "20px",
                                                        color: "#0009"
                                                    }}
                                                >
                                                    <>
                                                        <img
                                                            src={emptyImage}
                                                            alt="Empty"
                                                            width={"300px"}
                                                        />
                                                        <b>
                                                            No part details
                                                            available
                                                        </b>
                                                    </>
                                                </div>
                                            </>
                                        )}

                                        <Divider sx={{ mb: 2, mt: 4 }} />

                                        {/* Tool Details */}

                                        {pageDetails?.toolDetails?.length ? (
                                            <Typography
                                                variant="h6"
                                                fontWeight="bold"
                                                mt={4}
                                                mb={2}
                                                color="primary"
                                            >
                                                Tool Details
                                            </Typography>
                                        ) : null}

                                        {Object.keys(pageDetails?.toolDetails)
                                            .length > 0 ? (
                                            pageDetails.toolDetails.map(
                                                (
                                                    eachToolRec: any,
                                                    index: number
                                                ) => (
                                                    <>
                                                        <Box
                                                            key={index}
                                                            mb={3}
                                                            style={{
                                                                background:
                                                                    "#f5f7f8",
                                                                padding: "15px",
                                                                marginBottom:
                                                                    "15px"
                                                            }}
                                                        >
                                                            <Typography
                                                                fontSize={14}
                                                                fontWeight="bold"
                                                                mb={1}
                                                            >
                                                                Tool {index + 1}
                                                                :{" "}
                                                                {eachToolRec?.Tool_Name ||
                                                                    "-"}
                                                            </Typography>

                                                            <Box
                                                                display="grid"
                                                                gridTemplateColumns="repeat(4, 1fr)"
                                                                gap={4}
                                                                width="100%"
                                                                mb={3}
                                                                style={{
                                                                    background:
                                                                        "#f5f7f8",
                                                                    padding:
                                                                        "15px",
                                                                    marginBottom:
                                                                        "15px"
                                                                }}
                                                            >
                                                                <Stack
                                                                    spacing={
                                                                        0.5
                                                                    }
                                                                >
                                                                    <Typography
                                                                        variant="body2"
                                                                        color="text.secondary"
                                                                    >
                                                                        HSN No
                                                                    </Typography>
                                                                    <Typography variant="body2">
                                                                        {eachToolRec?.HSN_No ||
                                                                            "-"}
                                                                    </Typography>
                                                                </Stack>

                                                                <Stack
                                                                    spacing={
                                                                        0.5
                                                                    }
                                                                >
                                                                    <Typography
                                                                        variant="body2"
                                                                        color="text.secondary"
                                                                    >
                                                                        Unit Of
                                                                        Measurement
                                                                    </Typography>
                                                                    <Typography variant="body2">
                                                                        {eachToolRec?.UOM ||
                                                                            "-"}
                                                                    </Typography>
                                                                </Stack>

                                                                <Stack
                                                                    spacing={
                                                                        0.5
                                                                    }
                                                                >
                                                                    <Typography
                                                                        variant="body2"
                                                                        color="text.secondary"
                                                                    >
                                                                        Quantity
                                                                    </Typography>
                                                                    <Typography variant="body2">
                                                                        {eachToolRec?.Quantity ||
                                                                            "-"}
                                                                    </Typography>
                                                                </Stack>

                                                                <Stack
                                                                    spacing={
                                                                        0.5
                                                                    }
                                                                >
                                                                    <Typography
                                                                        variant="body2"
                                                                        color="text.secondary"
                                                                    >
                                                                        Unit
                                                                        Price
                                                                    </Typography>
                                                                    <Typography variant="body2">
                                                                        {eachToolRec?.Unit_Price ||
                                                                            "-"}
                                                                    </Typography>
                                                                </Stack>

                                                                {pageDetails
                                                                    ?.basicAndGeneralDetails
                                                                    ?.general_details
                                                                    ?.GST_Applicable ===
                                                                GST_APPLY_OPTIONS[0] ? (
                                                                    <>
                                                                        <Stack
                                                                            spacing={
                                                                                0.5
                                                                            }
                                                                        >
                                                                            <Typography
                                                                                variant="body2"
                                                                                color="text.secondary"
                                                                            >
                                                                                Total
                                                                                Amount
                                                                                (Excluding
                                                                                GST)
                                                                            </Typography>
                                                                            <Typography variant="body2">
                                                                                {`${eachToolRec?.Total_Amount_Exc_GST}` ||
                                                                                    "-"}
                                                                            </Typography>
                                                                        </Stack>

                                                                        <Stack
                                                                            spacing={
                                                                                0.5
                                                                            }
                                                                        >
                                                                            <Typography
                                                                                variant="body2"
                                                                                color="text.secondary"
                                                                            >
                                                                                Total
                                                                                Amount
                                                                                (Including
                                                                                GST)
                                                                            </Typography>
                                                                            <Typography variant="body2">
                                                                                {`${eachToolRec?.Total_Amount_Inc_GST}` ||
                                                                                    "-"}
                                                                            </Typography>
                                                                        </Stack>

                                                                        {pageDetails
                                                                            ?.basicAndGeneralDetails
                                                                            ?.general_details
                                                                            ?.GST_Type ===
                                                                            GST_TYPE_OPTIONS[1] && (
                                                                            <Stack
                                                                                spacing={
                                                                                    0.5
                                                                                }
                                                                            >
                                                                                <Typography
                                                                                    variant="body2"
                                                                                    color="text.secondary"
                                                                                >
                                                                                    GST
                                                                                    percent
                                                                                    (%)
                                                                                </Typography>
                                                                                <Typography variant="body2">
                                                                                    {eachToolRec?.GST_percent ||
                                                                                        "-"}
                                                                                </Typography>
                                                                            </Stack>
                                                                        )}
                                                                    </>
                                                                ) : (
                                                                    <Stack
                                                                        spacing={
                                                                            0.5
                                                                        }
                                                                    >
                                                                        <Typography
                                                                            variant="body2"
                                                                            color="text.secondary"
                                                                        >
                                                                            Total
                                                                            Amount
                                                                        </Typography>
                                                                        <Typography variant="body2">
                                                                            {`${eachToolRec?.Total_Amount_Exc_GST}` ||
                                                                                "-"}
                                                                        </Typography>
                                                                    </Stack>
                                                                )}

                                                                <Stack
                                                                    spacing={
                                                                        0.5
                                                                    }
                                                                >
                                                                    <Typography
                                                                        variant="body2"
                                                                        color="text.secondary"
                                                                    >
                                                                        Delivery
                                                                        Date
                                                                    </Typography>
                                                                    <Typography variant="body2">
                                                                        {eachToolRec?.Delivery_Date ||
                                                                            "-"}
                                                                    </Typography>
                                                                </Stack>
                                                            </Box>
                                                        </Box>
                                                    </>
                                                )
                                            )
                                        ) : (
                                            <></>
                                        )}

                                        {/* Purchase Order Value Details */}
                                        <Typography
                                            variant="h6"
                                            fontWeight="bold"
                                            mt={4}
                                            mb={2}
                                            color="primary"
                                        >
                                            Purchase Order Value
                                        </Typography>

                                        {Object?.keys(
                                            pageDetails?.basicAndGeneralDetails
                                                ?.purchase_order_value
                                        ).length > 0 ? (
                                            <>
                                                <Box
                                                    display="grid"
                                                    gridTemplateColumns="repeat(4, 1fr)"
                                                    gap={4}
                                                    width="100%"
                                                    mb={3}
                                                >
                                                    {pageDetails
                                                        ?.basicAndGeneralDetails
                                                        ?.general_details
                                                        ?.GST_Applicable ===
                                                    GST_APPLY_OPTIONS[0] ? (
                                                        <>
                                                            <Stack
                                                                spacing={0.5}
                                                            >
                                                                <Typography
                                                                    variant="body2"
                                                                    color="text.secondary"
                                                                >
                                                                    Total
                                                                    Purchase
                                                                    Order Value
                                                                    (Excluding
                                                                    GST)
                                                                </Typography>
                                                                <Typography variant="body2">
                                                                    {`${pageDetails?.basicAndGeneralDetails?.purchase_order_value?.Purchase_Order_Value_WithOut_GST}` ||
                                                                        "-"}
                                                                </Typography>
                                                            </Stack>

                                                            <Stack
                                                                spacing={0.5}
                                                            >
                                                                <Typography
                                                                    variant="body2"
                                                                    color="text.secondary"
                                                                >
                                                                    Total
                                                                    Purchase
                                                                    Order Value
                                                                    (Including
                                                                    GST)
                                                                </Typography>
                                                                <Typography variant="body2">
                                                                    {`${pageDetails?.basicAndGeneralDetails?.purchase_order_value?.Purchase_Order_Value_With_GST}` ||
                                                                        "-"}
                                                                </Typography>
                                                            </Stack>
                                                        </>
                                                    ) : (
                                                        <Stack spacing={0.5}>
                                                            <Typography
                                                                variant="body2"
                                                                color="text.secondary"
                                                            >
                                                                Total Purchase
                                                                Order Value
                                                            </Typography>
                                                            <Typography variant="body2">
                                                                {`${pageDetails?.basicAndGeneralDetails?.purchase_order_value?.Purchase_Order_Value_WithOut_GST}` ||
                                                                    "-"}
                                                            </Typography>
                                                        </Stack>
                                                    )}
                                                </Box>
                                            </>
                                        ) : (
                                            <>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "center",
                                                        gap: "8px",
                                                        padding: "20px",
                                                        color: "#0009"
                                                    }}
                                                >
                                                    <>
                                                        <img
                                                            src={emptyImage}
                                                            alt="Empty"
                                                            width={"300px"}
                                                        />
                                                        <b>
                                                            No Purchase Order
                                                            details available
                                                        </b>
                                                    </>
                                                </div>
                                            </>
                                        )}
                                    </TabPanel>
                                ) : (
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        height="50vh"
                                    >
                                        <ThreeDot
                                            color="#1976d2"
                                            size="medium"
                                            text=""
                                            textColor=""
                                        />
                                    </Box>
                                )}
                                {/* Part & Tools Details Section - End */}

                                {/* Document Details Section - Start */}
                                {!loading ? (
                                    <TabPanel value="3">
                                        {/* Basic Information */}
                                        <Typography
                                            variant="h6"
                                            fontWeight="bold"
                                            mb={2}
                                            color="primary"
                                        >
                                            Company Documents
                                        </Typography>

                                        <Box
                                            display="grid"
                                            gridTemplateColumns="repeat(1, 1fr)"
                                            gap={1}
                                            width="100%"
                                        >
                                            <Stack spacing={0.5}>
                                                {/* <Typography variant="body2" color="text.secondary">
                      Company Purchase Order
                    </Typography> */}
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        display: "flex",
                                                        cursor: "pointer"
                                                    }}
                                                    onClick={() => {
                                                        const fileUrl = getFile(
                                                            pageDetails?.customPoDocumentDetails
                                                        );
                                                        if (fileUrl) {
                                                            const link =
                                                                document.createElement(
                                                                    "a"
                                                                );
                                                            link.href = fileUrl;
                                                            link.download =
                                                                fileUrl
                                                                    .split("/")
                                                                    .pop() ||
                                                                coPoExtention;
                                                            document.body.appendChild(
                                                                link
                                                            );
                                                            link.click();
                                                            document.body.removeChild(
                                                                link
                                                            );
                                                        }
                                                    }}
                                                >
                                                    <Typography variant="body2">
                                                        {" "}
                                                        <img
                                                            src={pdfIcon}
                                                            alt="Company_Document"
                                                            style={{
                                                                width: "20px",
                                                                marginRight:
                                                                    "5px"
                                                            }}
                                                        />{" "}
                                                    </Typography>
                                                    <Typography fontSize={14}>
                                                        {coPoExtention ||
                                                            "COPO.pdf"}
                                                    </Typography>
                                                </Typography>
                                            </Stack>
                                        </Box>
                                    </TabPanel>
                                ) : (
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        height="50vh"
                                    >
                                        <ThreeDot
                                            color="#1976d2"
                                            size="medium"
                                            text=""
                                            textColor=""
                                        />
                                    </Box>
                                )}
                                {/* Document Details Section - End */}
                            </Box>
                        </TabContext>
                    </Box>
                    {/* Accordian Section - End */}
                </>
            ) : (
                <>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: "8px",
                            padding: "20px",
                            color: "#0009"
                        }}
                    >
                        <>
                            <img src={emptyImage} alt="Empty" width={"300px"} />
                            <b>No Record Found</b>
                        </>
                    </div>
                </>
            )}
        </>
    );
};
